<button class="cds-button s-solid c-primary gn-size-m" type="button" (click)="buttonClick()">Entrar</button>
